import 'slick-carousel/slick/slick'

export default class OurSupportersSlider {
    constructor() {
        this.settings = {
            el: $('.js-our-supporters-slider'),
            modalToggles: $('[data-supporters-modal-toggle]'),
            modals: $('.js-supporters-modal')
        };

        this.bindUIActions();
    }

    bindUIActions() {
        const { el, modalToggles, modals } = this.settings;

        if (el.length > 0) {
            el.each(function () {
                $(this).slick({
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    appendDots: $('.js-our-supporters-slider-dots'),
                });
            });
        }

        if (modalToggles.length > 0 && modals.length > 0) {
            modalToggles.on('click', function () {
                const toggleId = $(this).data('supporters-modal-toggle');
                const targetModal = $(`.js-supporters-modal[data-supporters-modal-toggle="${toggleId}"]`);

                targetModal.toggleClass('hidden');
            });
		};

    }
}

new OurSupportersSlider();